module.exports = __webpack_public_path__ + "static/img/14.c0950ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/5/eng/14.png
// module id = B+g7
// module chunks = 0